import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import LitterCard from '../card/litter-card';
import { LitterCardInterface } from '../../../structures/models/litter';

interface LitterCardSliderProps {
  litters: LitterCardInterface[];
}

const LitterCardSlider: React.FC<LitterCardSliderProps> = (data): ReactElement => {
  const { litters } = data;

  const settings: Settings = {
    infinite: false,
    slidesToShow: 4,
    rows: 1,
    speed: 500,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: litters.length > 3,
          centerMode: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          infinite: litters.length > 2,
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };

  if (litters.length > 0) {
    return (
      <>
        <Slider
          {...settings}
        >
          {litters.map((litter) => {
            return (
              <div key={litter.id}>
                <div className="react-litter-card">
                  <LitterCard
                    litter={litter}
                  />
                </div>
              </div>
            );
          })}
        </Slider>
      </>
    );
  }
  return (
    <div className="text-center">
      <h2>No litters found</h2>
    </div>
  );
};

export default LitterCardSlider;

if (document.getElementsByClassName('react-litter-card-slider').length > 0) {
  document.querySelectorAll('.react-litter-card-slider').forEach((element) => {
    const litters = JSON.parse(element.getAttribute('data-litters') ?? '[]');
    ReactDOM.render(<LitterCardSlider litters={litters} />, element);
  });
}
